export const BaseUrl = "https://api.thelpsedu.co.in"

// export const BaseUrl = "http://localhost:8002"
